import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import { node, oneOf, string } from 'prop-types';
import { VARIANT } from "./constants";
export var linkPropTypes = {
  children: node,
  href: string,
  variant: oneOf(Object.keys(VARIANT))
};